import React from "react";
import { Button, withStyles,CircularProgress } from "@material-ui/core";

const styles = (theme) => ({
  container: {
    flex: 1,
    zIndex: 2,
    display: "flex",
    position: "absolute",
    top: 0,
    width: "100%",
    height: "100%",
    backgroundColor: theme.ModalBGColor,
    justifyContent: "center",
    alignItems: "center",
  },
  content: {
    display: "flex",
    flexDirection: "column",
  },
  text: {
    color: theme.gridTextColor,
    paddingBottom: 20,
    paddingTop: 20,
    fontSize:12
  },
  progressIcon:{
    alignSelf:"center"
  },
  button: {
    textTransform: "none",
    display: "flex",
  },
});

const DispatchInProgress = ({ classes, close, delayed }) => {
  const message = delayed ?  "Dispatching driver is taking more time" : "Dispatch Driver is in progress";
  return (
    <div className={classes.container}>
      <div className={classes.content}>
      <CircularProgress className={classes.progressIcon}/>
        <div className={classes.text}> {message} </div>
        {delayed ? (
          <Button
            variant="contained"
            color="primary"
            size="medium"
            onClick={close}
            classes={{
              root: classes.actionButton,
            }}
            id={"close"}
          >
            Close
          </Button>
        ) : null}
      </div>
    </div>
  );
};

export default withStyles(styles)(DispatchInProgress);
